/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: utils-service.ts
 *
 * Created by sjacobs on 3/16/18.
 */

'use strict';

angular.module('prism-ui.components').service('DeliveryItemsService', function (
    this: JS5Object, _: JS5Object,
    $q: JS5Object,
    LanguagesService: JS5Object,
    RolesService: JS5Object,
    MediaConversionTemplateService: JS5Object,
    AssetContentTemplatesService: JS5Object,
    ConditionalTemplatesService: JS5Object,
    TransformTemplatesService: JS5Object,
    MacCaptionTemplatesService: JS5Object,
    MediaAcceptProfileService: JS5Object,
    MetadataEditService: JS5Object,
    PartnerEditService: JS5Object
) {
    this.getDeliveryItemEditViewFormData = (partnerId) => {
        let deliveryItemDefaultMetadataPromise = MetadataEditService.getMetadataByGroup('Media Conversion')
            .then((metadataItems: JS5Object[]) => {
                let defaultMetadata: JS5Object = {};
                _.forEach(metadataItems, (metadataItem: JS5Object) => {
                    defaultMetadata[metadataItem.name] = {
                        mvpd: metadataItem.mvpd,
                        required: false,
                        valueOverridden: false
                    };
                });
                return defaultMetadata;
            });
        return $q.all({
            mediaConversionTemplates: MediaConversionTemplateService.getAllMediaConversionTemplates(),
            macCaptionTemplates: MacCaptionTemplatesService.getAllMacCaptionTemplates(),
            conditionalTemplates: ConditionalTemplatesService.getAllConditionalTemplates(),
            transformTemplates: TransformTemplatesService.getAllTransformTemplates(),
            languages: LanguagesService.getAllLanguages(),
            roles: RolesService.getAllRoles(),
            assetContentTemplates: AssetContentTemplatesService.getAllAssetContentTemplates(),
            mediaAcceptProfiles: MediaAcceptProfileService.getAcceptProfiles({fetchLimit: 0}),
            deliveryEndpointsForPartner: PartnerEditService.getDeliveryEndpointsForPartner(partnerId),
            deliveryItemDefaultMetadata: deliveryItemDefaultMetadataPromise
        });
    };
    this.getSearchViewColumnDefinitions = (deliveryItemType: string) => {
        let columnDefinitions = [];
        switch (deliveryItemType) {
            case 'Archive':
                columnDefinitions = [
                    {
                        field: 'name',
                        displayName: 'Name',
                        width: '500',
                        sort: {
                            direction: 'asc',
                        },
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'sourceEndpoint.name',
                        displayName: 'FROM',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'deliveryEndpoint.name',
                        displayName: 'TO',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'targetPathExpression',
                        displayName: 'Target Path',
                        width: '500',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    }
                ];

                break;
            case 'Artwork':
                columnDefinitions = [
                    {
                        field: 'name',
                        displayName: 'Name',
                        sort: {
                            direction: 'asc',
                        },
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'sourceMediaAcceptProfile.name',
                        displayName: 'From Artwork MAP',
                        width: '500',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'targetContentTemplate.name',
                        displayName: 'To Template',
                        width: '500',
                        cellTemplate: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/searchView/cell-templates/to-template-cell-template.html'
                    },
                    {
                        field: 'deliveryEndpoint.name',
                        displayName: 'Via',
                        width: '500',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'targetPathExpression',
                        displayName: 'Target Path',
                        width: '500',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    }
                ];
                break;
            case 'Audio':
                columnDefinitions = [
                    {
                        field: 'name',
                        displayName: 'Name',
                        sort: {
                            direction: 'asc',
                        },
                        width: '500',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'sourceMediaAcceptProfile.name',
                        displayName: 'From Audio MAP',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'mediaConversionTemplate',
                        displayName: 'To Template',
                        cellTemplate: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/searchView/cell-templates/to-template-cell-template.html'
                    },
                    {
                        field: 'deliveryEndpoint.name',
                        displayName: 'Via',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'targetPathExpression',
                        displayName: 'Target Path',
                        width: '500',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    }
                ];
                break;
            case 'CC':
                columnDefinitions = [
                    {
                        field: 'name',
                        displayName: 'Name',
                        sort: {
                            direction: 'asc',
                        },
                        width: '500',
                        cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'targetContentTemplate.name',
                        displayName: 'To Format',
                        cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'deliveryEndpoint.name',
                        displayName: 'Via',
                        cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'targetPathExpression',
                        displayName: 'Target Path',
                        width: '500',
                        cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                    }
                ];

                break;
            case 'Image':
                columnDefinitions = [
                    {
                        field: 'name',
                        displayName: 'Name',
                        sort: {
                            direction: 'asc',
                        },
                        width: '500',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'sourceMediaAcceptProfile.name',
                        displayName: 'From Images MAP',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'targetContentTemplate.name',
                        displayName: 'To Template',
                        cellTemplate: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/searchView/cell-templates/to-template-cell-template.html'
                    },
                    {
                        field: 'deliveryEndpoint.name',
                        displayName: 'Via',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'targetPathExpression',
                        displayName: 'Target Path',
                        width: '500',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    }
                ];
                break;
            case 'Metadata':
                columnDefinitions = [
                    {
                        field: 'name',
                        displayName: 'Name',
                        sort: {
                            direction: 'asc',
                        },
                        width: '500',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'xslTemplate.name',
                        displayName: 'XSLT',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'deliveryEndpoint.name',
                        displayName: 'Via',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'targetPathExpression',
                        displayName: 'Target Path',
                        width: '500',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    }
                ];
                break;
            case 'Subtitle':
                columnDefinitions = [
                    {
                        field: 'name',
                        displayName: 'Name',
                        sort: {
                            direction: 'asc',
                        },
                        width: '500',
                        cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'targetContentTemplate.name',
                        displayName: 'To Format',
                        cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'deliveryEndpoint.name',
                        displayName: 'Via',
                        cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'targetPathExpression',
                        displayName: 'Target Path',
                        width: '500',
                        cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                    }
                ];
                break;
            case 'Video':
                columnDefinitions = [
                    {
                        field: 'name',
                        displayName: 'Name',
                        sort: {
                            direction: 'asc',
                        },
                        width: '500',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'mediaConversionTemplate',
                        displayName: 'To Template',
                        cellTemplate: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/searchView/cell-templates/to-template-cell-template.html'
                    },
                    {
                        field: 'deliveryEndpoint.name',
                        displayName: 'Via',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    },
                    {
                        field: 'targetPathExpression',
                        displayName: 'Target Path',
                        width: '500',
                        cellItem: 'components/visual/grid/padded-base-tooltip-template.html'
                    }
                ];
                break;
            default:
                console.warn(`Could not get visible column definitions, Unknown Delivery Item Edit View specified. [${deliveryItemType}]`);
                break;
        }
        return columnDefinitions;
    };
    this.getVisibleEditViewPanels = (deliveryItemType: string) => {
        let visiblePanels = {};
        switch (deliveryItemType) {
            case 'Archive':
                visiblePanels = {
                    general: true,
                    archive: true,
                    delivery: true,
                    redelivery: true,
                    partnerFormat: true
                };
                break;
            case 'Artwork':
                visiblePanels = {
                    general: true,
                    from: true,
                    to: true,
                    delivery: true,
                    redelivery: true,
                    partnerFormat: true
                };
                break;
            case 'Audio':
                visiblePanels = {
                    general: true,
                    from: true,
                    to: true,
                    delivery: true,
                    redelivery: true,
                    partnerFormat: true
                };
                break;
            case 'CC':
                visiblePanels = {
                    general: true,
                    from: true,
                    to: true,
                    delivery: true,
                    redelivery: true,
                    partnerFormat: true
                };
                break;
            case 'Image':
                visiblePanels = {
                    general: true,
                    from: true,
                    to: true,
                    delivery: true,
                    redelivery: true,
                    partnerFormat: true
                };
                break;
            case 'Metadata':
                visiblePanels = {
                    general: true,
                    to: true,
                    delivery: true,
                    redelivery: true,
                    partnerFormat: true
                };
                break;
            case 'Subtitle':
                visiblePanels = {
                    general: true,
                    from: true,
                    to: true,
                    delivery: true,
                    redelivery: true,
                    partnerFormat: true
                };
                break;
            case 'Video':
                visiblePanels = {
                    general: true,
                    from: true,
                    to: true,
                    audioChannelMapping: true,
                    closedCaptioningSubtitle: true,
                    postDeliveryProcessing: true,
                    adPartnerProperties: true,
                    delivery: true,
                    redelivery: true,
                    partnerFormat: true,
                    vantageMd5: true
                };
                break;
            default:
                console.warn(`Could not get visible panels, Unknown Delivery Item Edit View specified. [${deliveryItemType}]`);
                break;
        }
        return visiblePanels;
    };
});
